export interface RecentQuery {
  key: number;
  value: string;
  quickSearch?: boolean;
  bespoke?: boolean;
  name?: string;
  address?: string;
}

export interface RouteFeature {
  name: string;
  id: string;
  address: string;
}

export enum QueryParamBinary {
  ENABLED = "enable",
  DISABLED = "disable",
}

export enum QueryParam {
  STEP_FREE = "step-free",
  FEATURE_ID = "feature",
  QUERY = "query",
  MILESTONE_INDEX = "milestone-index",
  QUICK_SEARCH = "quick-search",
  SEARCH_TAG_TYPE = "search-tag-type",
  NAME_SEARCH = "name-search",
  LANG = "lang",
}

export enum MapQueryParam {
  UI_CONTROLS = "ui-controls",
  UI_GESTURES = "ui-gestures",
  UI_SEARCH = "ui-search",
  UI_FEATURE = "ui-feature",
  GEOLOCATION = "geolocation",
  FLOOR = "floor",
  MARKER = "marker",
  CALLBACK = "callback",
  DEBUG = "debug",
  POSITION_LOGGING = "position-logging",
  POSITION_LOGGING_SESSION_UUID = "position-logging-session-uuid",
  PLUGIN = "plugin",
  CONSOLE_LOCATION = "console-location",
  SOURCE = "source",
}

// to combine enums we need to declare a type and a const with the same name https://stackoverflow.com/questions/52857698/extending-enum-in-typescript/71255520#71255520
export type QueryParams = QueryParam | MapQueryParam;
// eslint-disable-next-line
export const QueryParams = { ...QueryParam, ...MapQueryParam };

export enum Path {
  HOME = "",
  FEATURE = "poi",
  SEARCH = "search",
  ROUTE = "route/:fromId/:toId",
  NAVIGATE = "navigate/:fromId/:toId",
  NAVIGATE_ALT = "navigate/:fromName/:fromUid/:toName/:toUid",
  NAVIGATE_FLOOR = "navigate/:fromId/:toId/:floorName",
  JOURNEY = "journey/:fromId/:toId",
  JOURNEY_OVERVIEW = "journey-overview/:fromId/:toId",
}

export enum RoutingPath {
  ROUTE = "route",
  NAVIGATE = "navigate",
  NAVIGATE_ALT = "navigate",
  NAVIGATE_FLOOR = "navigate",
  JOURNEY = "journey",
  JOURNEY_OVERVIEW = "journey-overview",
}

export type routingPaths =
  | RoutingPath.ROUTE
  | RoutingPath.NAVIGATE
  | RoutingPath.NAVIGATE_ALT
  | RoutingPath.NAVIGATE_FLOOR
  | RoutingPath.JOURNEY
  | RoutingPath.JOURNEY_OVERVIEW;
